/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const LogoutResponseParser = /* #__PURE__ */ parsers.object([]);
export class LogoutResponse extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LogoutResponseParser.decode(input).map(res => new LogoutResponse(res));
    }
    static unsafeDecode(input) {
        return LogoutResponse.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LogoutResponseParser.encode(data);
    }
    static schema() {
        return LogoutResponseParser.schema();
    }
}
